import(/* webpackMode: "eager" */ "/app/node_modules/@cobasi/ds-tokens/dist/css/globals/tokens.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@cobasi/ds-tokens/dist/css/cobasi/tokens.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@cobasi/ds-tokens/dist/css/pet-anjo/tokens.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@cobasi/ds-components/dist/css/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@cobasi/ds-components-react/dist/styles/main.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/AnalyticsPageView/analyticsPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/TopProgressBar/topProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/ReactNativeAppProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/_globals.scss");
